import React, { useState, useContext, useMemo } from 'react';

// 1. Создаем контекст
export const ThemeContext = React.createContext();

// 2. Создаем Provider с состоянием
export const ThemeProvider = ({ children }) => {
  const [valueContext, setValueContext] = useState([]);

  // Используем useMemo для оптимизации
  const contextValue = useMemo(() => ({ valueContext, setValueContext }), [valueContext]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};